import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import app from 'flarum/forum/app';
const EXTENSION_ID = 'crashcart-social-profiles';
const CARD_ID = 'CrashCartSocialProfile';
const MOUNT_ID = 'CrashCartSocialProfileMount';
const fields = [['ccgProfileTitle', 'Profile headline', 'text', 80, 'Welcome to my gaming profile!'], ['ccgProfileStatus', 'Status', 'text', 160, 'What are you up to?'], ['ccgProfileMood', 'Mood', 'text', 40, 'Ready to play'], ['ccgProfileAbout', 'About me', 'textarea', 1500, 'Tell the community about yourself.'], ['ccgProfileCurrentlyPlaying', 'Currently playing', 'text', 120, 'Minecraft, retro games…'], ['ccgProfileFavoriteGames', 'Favorite games', 'textarea', 700, 'One game per line or a comma-separated list'], ['ccgProfilePlatforms', 'Platforms', 'text', 240, 'PC, PlayStation, Xbox, Nintendo…'], ['ccgProfileInterests', 'Other interests', 'textarea', 700, 'Board games, cards, collecting…'], ['ccgProfileLocation', 'Location', 'text', 100, 'Westchester County, NY'], ['ccgProfileSongUrl', 'Profile song link', 'url', 500, 'https://… (no autoplay)'], ['ccgProfileTopFriends', 'Top friends', 'text', 500, 'Usernames separated by commas']];
function attr(user, name, fallback) {
  var _user$attribute;
  if (fallback === void 0) {
    fallback = '';
  }
  const value = user == null || (_user$attribute = user.attribute) == null ? void 0 : _user$attribute.call(user, name);
  return value === null || value === undefined ? fallback : String(value);
}
function el(tag, className, text) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  return node;
}
function splitList(value) {
  return String(value || '').split(/[\n,]+/).map(item => item.trim()).filter(Boolean).slice(0, 24);
}
function safeUrl(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
  } catch (_) {
    return null;
  }
}
function userForPage() {
  var _app$current, _app$current$get, _app$store, _app$store$all;
  const current = (_app$current = app.current) == null || (_app$current$get = _app$current.get) == null ? void 0 : _app$current$get.call(_app$current, 'user');
  if (current) return current;
  const match = window.location.pathname.match(/\/u\/([^/]+)/);
  if (!match) return null;
  const slug = decodeURIComponent(match[1]);
  const users = ((_app$store = app.store) == null || (_app$store$all = _app$store.all) == null ? void 0 : _app$store$all.call(_app$store, 'users')) || [];
  return users.find(user => {
    var _user$slug, _user$username;
    return ((_user$slug = user.slug) == null ? void 0 : _user$slug.call(user)) === slug || ((_user$username = user.username) == null ? void 0 : _user$username.call(user)) === slug;
  }) || null;
}
function detail(label, value) {
  if (!value) return null;
  const row = el('div', 'CrashCartProfile-detail');
  row.append(el('dt', '', label), el('dd', '', value));
  return row;
}
function panel(title, content, extraClass) {
  if (extraClass === void 0) {
    extraClass = '';
  }
  const box = el('section', "CrashCartProfile-panel ".concat(extraClass).trim());
  box.append(el('h3', 'CrashCartProfile-panelTitle', title));
  const body = el('div', 'CrashCartProfile-panelBody');
  if (content instanceof Node) body.append(content);else body.textContent = content || 'Not filled out yet.';
  box.append(body);
  return box;
}
function topFriends(user) {
  const names = splitList(attr(user, 'ccgProfileTopFriends')).slice(0, 8);
  const grid = el('div', 'CrashCartProfile-friends');
  if (!names.length) {
    grid.append(el('p', 'CrashCartProfile-empty', 'No top friends selected yet.'));
    return grid;
  }
  names.forEach(name => {
    const link = el('a', 'CrashCartProfile-friend');
    link.href = "".concat(app.forum.attribute('baseUrl').replace(/\/$/, ''), "/u/").concat(encodeURIComponent(name));
    link.append(el('span', 'CrashCartProfile-friendAvatar', name.slice(0, 1).toUpperCase()));
    link.append(el('span', 'CrashCartProfile-friendName', name));
    grid.append(link);
  });
  return grid;
}
function renderProfile(user) {
  var _app$session;
  const root = el('article', "CrashCartProfile is-".concat(attr(user, 'ccgProfileLayout', 'classic')));
  root.id = CARD_ID;
  root.style.setProperty('--ccg-profile-accent', attr(user, 'ccgProfileAccent', '#ff1824'));
  root.style.setProperty('--ccg-profile-bg', attr(user, 'ccgProfileBackground', '#061432'));
  const header = el('header', 'CrashCartProfile-header');
  const heading = el('div', 'CrashCartProfile-heading');
  heading.append(el('p', 'CrashCartProfile-eyebrow', 'CRASHCART COMMUNITY PROFILE'));
  heading.append(el('h2', '', attr(user, 'ccgProfileTitle') || "".concat(user.displayName(), "\u2019s Gaming Space")));
  const status = attr(user, 'ccgProfileStatus');
  if (status) heading.append(el('p', 'CrashCartProfile-status', "\u201C".concat(status, "\u201D")));
  header.append(heading);
  const sessionUser = (_app$session = app.session) == null ? void 0 : _app$session.user;
  if (sessionUser && String(sessionUser.id()) === String(user.id())) {
    const edit = el('button', 'Button Button--primary CrashCartProfile-edit', 'Customize Profile');
    edit.type = 'button';
    edit.addEventListener('click', () => openEditor(user));
    header.append(edit);
  }
  root.append(header);
  const columns = el('div', 'CrashCartProfile-columns');
  const side = el('div', 'CrashCartProfile-side');
  const details = el('dl', 'CrashCartProfile-details');
  [detail('Mood', attr(user, 'ccgProfileMood')), detail('Currently playing', attr(user, 'ccgProfileCurrentlyPlaying')), detail('Platforms', attr(user, 'ccgProfilePlatforms')), detail('Location', attr(user, 'ccgProfileLocation'))].filter(Boolean).forEach(row => details.append(row));
  side.append(panel('Player Details', details, 'is-details'));
  side.append(panel('Top 8', topFriends(user), 'is-friends'));
  const song = safeUrl(attr(user, 'ccgProfileSongUrl'));
  if (song) {
    const link = el('a', 'Button CrashCartProfile-song', '♫ Open Profile Song');
    link.href = song;
    link.target = '_blank';
    link.rel = 'noopener noreferrer nofollow';
    side.append(panel('Profile Song', link, 'is-song'));
  }
  const main = el('div', 'CrashCartProfile-main');
  main.append(panel('About Me', attr(user, 'ccgProfileAbout')));
  const favorites = el('div', 'CrashCartProfile-tags');
  splitList(attr(user, 'ccgProfileFavoriteGames')).forEach(game => favorites.append(el('span', '', game)));
  main.append(panel('Favorite Games', favorites.childElementCount ? favorites : 'Not filled out yet.'));
  main.append(panel('Beyond the Screen', attr(user, 'ccgProfileInterests')));
  columns.append(side, main);
  root.append(columns);
  return root;
}
function formGroup(label, input) {
  const group = el('label', 'CrashCartProfileEditor-group');
  group.append(el('span', '', label), input);
  return group;
}
function inputFor(user, definition) {
  const _definition = _slicedToArray(definition, 5),
    name = _definition[0],
    type = _definition[2],
    maxLength = _definition[3],
    placeholder = _definition[4];
  const input = document.createElement(type === 'textarea' ? 'textarea' : 'input');
  input.name = name;
  if (type !== 'textarea') input.type = type;
  input.maxLength = maxLength;
  input.placeholder = placeholder;
  input.value = attr(user, name);
  if (type === 'textarea') input.rows = name === 'ccgProfileAbout' ? 5 : 3;
  return input;
}
function select(name, options, selected) {
  const control = document.createElement('select');
  control.name = name;
  options.forEach(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      label = _ref2[1];
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    option.selected = value === selected;
    control.append(option);
  });
  return control;
}
function openEditor(user) {
  if (document.querySelector('.CrashCartProfileEditor')) return;
  const backdrop = el('div', 'CrashCartProfileEditor');
  const dialog = el('section', 'CrashCartProfileEditor-dialog');
  dialog.setAttribute('role', 'dialog');
  dialog.setAttribute('aria-modal', 'true');
  dialog.setAttribute('aria-label', 'Customize profile');
  const top = el('header', 'CrashCartProfileEditor-header');
  top.append(el('h2', '', 'Customize Your Profile'));
  const close = el('button', 'Button Button--icon', '×');
  close.type = 'button';
  close.setAttribute('aria-label', 'Close');
  top.append(close);
  dialog.append(top);
  const form = document.createElement('form');
  form.className = 'CrashCartProfileEditor-form';
  fields.forEach(definition => form.append(formGroup(definition[1], inputFor(user, definition))));
  const colors = el('div', 'CrashCartProfileEditor-colors');
  [['ccgProfileAccent', 'Accent color', '#ff1824'], ['ccgProfileBackground', 'Background color', '#061432']].forEach(_ref3 => {
    let _ref4 = _slicedToArray(_ref3, 3),
      name = _ref4[0],
      label = _ref4[1],
      fallback = _ref4[2];
    const input = document.createElement('input');
    input.type = 'color';
    input.name = name;
    input.value = attr(user, name, fallback);
    colors.append(formGroup(label, input));
  });
  form.append(colors);
  form.append(formGroup('Profile style', select('ccgProfileLayout', [['classic', 'Classic social profile'], ['arcade', 'Arcade glow'], ['clean', 'Clean and modern']], attr(user, 'ccgProfileLayout', 'classic'))));
  form.append(formGroup('Who can see these details?', select('ccgProfileVisibility', [['everyone', 'Everyone'], ['members', 'Logged-in members'], ['private', 'Only me and administrators']], attr(user, 'ccgProfileVisibility', 'everyone'))));
  const message = el('p', 'CrashCartProfileEditor-message');
  const actions = el('footer', 'CrashCartProfileEditor-actions');
  const cancel = el('button', 'Button', 'Cancel');
  cancel.type = 'button';
  const save = el('button', 'Button Button--primary', 'Save Profile');
  save.type = 'submit';
  actions.append(message, cancel, save);
  form.append(actions);
  dialog.append(form);
  backdrop.append(dialog);
  document.body.append(backdrop);
  const dismiss = () => backdrop.remove();
  close.addEventListener('click', dismiss);
  cancel.addEventListener('click', dismiss);
  backdrop.addEventListener('click', event => {
    if (event.target === backdrop) dismiss();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    save.disabled = true;
    message.textContent = 'Saving…';
    const data = {};
    new FormData(form).forEach((value, key) => {
      data[key] = String(value).trim() || null;
    });
    try {
      var _document$getElementB;
      await user.save(data);
      dismiss();
      (_document$getElementB = document.getElementById(CARD_ID)) == null || _document$getElementB.replaceWith(renderProfile(user));
    } catch (error) {
      var _error$response;
      message.textContent = (error == null || (_error$response = error.response) == null || (_error$response = _error$response.errors) == null || (_error$response = _error$response[0]) == null ? void 0 : _error$response.detail) || 'Could not save. Please check the fields and try again.';
      save.disabled = false;
    }
  });
}
function mountProfile() {
  if (!/\/u\/[^/]+/.test(window.location.pathname)) return;
  const user = userForPage();
  if (!user) return;

  // Flarum 2 uses Page-container/Page-content as the grid that holds both the
  // profile navigation and the selected tab. Inserting the profile into that
  // element creates an unintended third, very narrow column. Mount a sibling
  // container immediately before the grid so the custom profile gets the full
  // page width while Flarum's navigation remains intact underneath it.
  const pageGrid = document.querySelector('.UserPage .Page-container');
  if (pageGrid) {
    let mount = document.getElementById(MOUNT_ID);
    if (!mount) {
      mount = el('div', 'container CrashCartProfileMount');
      mount.id = MOUNT_ID;
      pageGrid.before(mount);
    }
    if (mount.dataset.userId !== String(user.id()) || !mount.querySelector("#".concat(CARD_ID))) {
      mount.dataset.userId = String(user.id());
      mount.replaceChildren(renderProfile(user));
    }
    return;
  }
  if (document.getElementById(CARD_ID)) return;
  const target = document.querySelector('.UserPage-content, .UserPage .Page-content');
  if (!target) return;
  target.prepend(renderProfile(user));
}
app.initializers.add(EXTENSION_ID, () => {
  const observer = new MutationObserver(() => window.requestAnimationFrame(mountProfile));
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.requestAnimationFrame(mountProfile);
});